import { render, staticRenderFns } from "./IntegrationExt99.vue?vue&type=template&id=4f822784&"
import script from "./IntegrationExt99.vue?vue&type=script&lang=js&"
export * from "./IntegrationExt99.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports